// Peer Deps
import * as React from "react";
import * as reactDom from "react-dom";
// @ts-ignore
import * as AbImpression from "@vp/ab-impression";
import * as AbReader from "@vp/ab-reader";
// @ts-ignore
import * as Auth from "@vp/auth";
import { SearchBarProps } from "@vp/omnisearch";
import { CartTenantDetails } from "@vp/cart-client";
import * as Swan from "@vp/swan";
import { v4 } from "uuid";
// @ts-ignore
import * as QueryString from "query-string";
//Imports for things where we use the default export must use the default import
//or NextJS gets unhappy when we try to access it in our html generation bundle
import Axios from "axios";

import { Header, HeaderProps } from "./components/Header";
import { Footer, FooterProps } from "./components/Footer";
import { BOOKENDS_META_TAG_NAME, BOOKEND_TYPES, BOOKENDS_SWAN_STYLES } from "./constants";
import { getHeaderComponentSlug, getFooterComponentSlug, BookendsMetaTag } from "components/HeadTag";
import { getHeaderKey, getFooterKey } from './components/helpers'

declare global {
  interface Window {
    bookends: {
      React: any,
      ReactDOM: any,
      AbImpression: any,
      AbReader: any,
      Auth: any,
      Axios: any,
      Swan: any,
      Uuid: any,
      QueryString: any,
      trackingConfiguration?: TrackingConfiguration
      deepLink?: DeepLink
      SearchBarConfig?: SearchBarProps
      useMiniCart?: boolean
      MiniCartConfig?: {tenantDetails?: CartTenantDetails}
    }
    bundleInterval: any,
    ComponentWrapper: any,
    full_header_componentWrapperInterval: any,
    full_header_props: any,
    slim_header_componentWrapperInterval: any,
    slim_header_props: any,
    full_footer_componentWrapperInterval: any,
    full_footer_props: any,
    slim_footer_componentWrapperInterval: any,
    slim_footer_props: any,
    bookendsHeaderVariation: string,
    bookendsFooterVariation: string
  }
}

if (typeof window !== "undefined") {
    window.bookends = {
        React: React,
        ReactDOM: reactDom,
        AbImpression,
        AbReader,
        Auth,
        Axios,
        Swan,
        Uuid: { v4 },
        QueryString
    }
}

export {
    Header,
    HeaderProps,
    Footer,
    FooterProps,
    BOOKENDS_SWAN_STYLES,
    BOOKEND_TYPES,
    BOOKENDS_META_TAG_NAME,
    getHeaderComponentSlug,
    getFooterComponentSlug,
    getHeaderKey,
    getFooterKey,
    BookendsMetaTag,
}